import React from 'react';

const FooterPage = () => (
    <div>
        <footer className="footer">
            <div className="footer__content">

                <p >Copyright &copy; 2020 <a href="/" >Expense App</a>&nbsp; . All rights reserved.</p>


            </div>


        </footer>


    </div>
);

export default FooterPage;



// WEBPACK FOOTER //
// ./src/components/Footer.js